import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonProps } from '@mui/material/Button';

interface LoadingButtonProps {
  buttonName?: string;
  variant?: ButtonProps['variant'];
  onClickButton?: (e: any) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  size?: ButtonProps['size'];
  fullWidth?: boolean;
  sx?: any
  type?: ButtonProps['type'];
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  buttonName = 'Submit',
  type = 'button',
  variant = 'contained',
  onClickButton,
  isLoading = false,
  isDisabled = false,
  size = 'small',
  fullWidth = false,
  sx = {},
}) => {
  return (
    <Button
      sx={sx}
      variant={variant}
      disabled={isDisabled || isLoading}
      onClick={onClickButton}
      size={size}
      fullWidth={fullWidth}
      startIcon={
        isLoading && (
          <CircularProgress
            size={20}
            sx={{ color: 'white' }} // Change color as needed
          />
        )
      }
      type={type}
    >
      {isLoading ? '' : buttonName}
    </Button>
  );
};

export default LoadingButton;
